export class Reporter {
	// This type is fine
	// eslint-disable-next-line @typescript-eslint/ban-types
	// biome-ignore lint/complexity/noBannedTypes: suppressed due to migration - should be fixed
	constructor(private readonly fn: Function) {
		// Empty
	}

	public log(message: string): void {
		this.fn(message);
	}
}
